<template>
  <div v-if="multiple" class="tags flex flex-wrap truncate">
    <div
      v-for="(node, index) in nodes"
      :key="index"
      class="tag flex items center mr-2 my-1"
    >
      <Vnodes :vnodes="node.componentOptions.children" />
      <i
        @click.stop="$emit('unselect', node.componentOptions.propsData.value)"
        class="unselect far fa-times ml-1"
      ></i>
    </div>
  </div>
  <div v-else class="truncate">
    <Vnodes :vnodes="nodes.componentOptions.children" />
  </div>
</template>

<script>
export default {
  name: 'SelectReference',
  components: {
    Vnodes: {
      functional: true,
      render: (h, ctx) => h('span', {class: {node: true}}, ctx.props.vnodes),
    },
  },
  props: ['nodes', 'multiple'],
};
</script>

<style lang="scss">
.tags {
  display: flex;
}

.tag {
  display: flex;
  max-width: 150px;

  @apply truncate
    text-xs
    capitalize
    items-center
    text-center 
    rounded 
    border 
    border-dull 
    py-1 
    px-2;

  .node {
    // max-width: 100px;
    @apply truncate;
  }
}

.unselect {
  @apply text-dull;
}
</style>
